<!-- <h1 mat-dialog-title>Delete User</h1>
<div mat-dialog-content>
    <form [formGroup]="userDeleteForm">
        <mat-form-field class="form-element" style="width: 0; height: 0;">
            <input matInput hidden formControlName="id" readonly>
        </mat-form-field>

        <mat-form-field class="form-element">
            <input matInput formControlName="userName" readonly>
            <button mat-button color="primary"  matSuffix mat-icon-button (click)="deleteUser(userDto.id)"> 
                <mat-icon>delete</mat-icon>
            </button>
        </mat-form-field>
    </form>
</div> -->

<div class="card">
    <div class="card-header card-header-squirrel">
        <h4>{{this.translate.data['TOOLTIPREMOVEUSER'] | translate}}</h4>
        <!-- <h6>{{this.translate.data['USER'] | translate}}: {{userName}}</h6> -->
    </div>

    <div class="card-body">
        <form [formGroup]="userDeleteForm">
            <mat-form-field class="example-full-width" style="width: 0; height: 0;">
                <input matInput hidden formControlName="id" readonly>
            </mat-form-field>
    
            <mat-form-field class="example-full-width">
                <input matInput formControlName="userName" readonly>
                <!-- <button mat-button color="primary"  matSuffix mat-icon-button (click)="deleteUser(userDto.id)"> 
                    <mat-icon>delete</mat-icon>
                </button> -->
            </mat-form-field>
            <button mat-raised-button class="btn btn-squirrel" style="margin-top: 6px;margin-left: 0px" matTooltip="{{this.translate.data['TOOLTIPCLOSEADDUSERDIALOG'] | translate}}"
                (click)="cancel()" >Abbruch</button>
            <button  mat-raised-button class="btn btn-squirrel pull-right" (click)="deleteUser(userDto.id)" color="primary">Entfernen</button>
        </form>
    </div>
</div>